module.exports = __webpack_public_path__ + "img/AdsBanner.14e37afc.jpg";